export default __webpack_public_path__ + "static/media/klinikUnismuh.5d53701e.jpg";